module.exports = __webpack_public_path__ + "img/dhl.3b1c959c.png";